const axios = require('axios');
const moment = require('moment');
const localforage = require('localforage');

const CACHE_TIME = 2 * 60 * 60 * 1000; // 2hr*60m*60s*1000ms
function restService() {
  this.getStores = function () {
    return new Promise((resolve, reject) => {
      localforage
        .getItem('storests')
        .then((storests) => {
          // This code runs once the value has been loaded
          // from the offline store.
          console.log(storests);
          if (
            moment().valueOf() - moment(storests).valueOf() >= CACHE_TIME ||
            storests === null
          ) {
            console.log('fetching ' + 'operating?fields=all');
            axios
              .get('operating?fields=all')
              .then((res) => {
                localforage.setItem('stores', res.data).then(() => {
                  localforage
                    .setItem('storests', moment().valueOf())
                    .then(() => {
                      resolve(res.data);
                    });
                });
              })
              .catch((error) => {
                console.log(error.response);
                reject(error);
              });
          } else {
            console.log('form cache ' + 'operating?fields=all');
            localforage
              .getItem('stores')
              .then((value) => {
                resolve(value);
              })
              .catch((err) => {
                reject(err);
              });
          }
        })
        .catch((err) => {
          // This code runs if there were any errors
          console.log(err);
        });
    });
  };
  this.getUser = function (user) {
    console.log('GET USER');
    return new Promise((resolve, reject) => {
      localforage
        .getItem('userts')
        .then((userts) => {
          console.log(userts);
          if (userts === null) {
            console.log('fetching ' + 'res_users?fields=all&domain');
            axios
              .get(
                `res_users?fields=all&domain=[('login','=','${user}')]`,
                {},
              )
              .then((res) => {
                localforage.setItem('user', res.data).then(() => {
                  localforage.setItem('userts', moment().valueOf()).then(() => {
                    resolve(res.data[0]);
                  });
                });
              })
              .catch((error) => {
                console.log(error.response);
                reject(error);
              });
          } else {
            console.log('from cache  ' + 'res_users?fields=all&domain');
            localforage
              .getItem('user')
              .then((value) => {
                resolve(value);
              })
              .catch((err) => {
                reject(err);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };
  this.getStockLot = function () {
    console.log('GET stock lot');
    return new Promise((resolve, reject) => {
      localforage
        .getItem('stocklotts')
        .then((stocklotts) => {
          console.log(stocklotts);
          if (
            moment().valueOf() - moment(stocklotts).valueOf() >= CACHE_TIME ||
            stocklotts === null
          ) {
            console.log('fetching ' + 'stocklot');
            axios
              .get('stock_lot?fields=all')
              .then((res) => {
                localforage.setItem('stocklot', res.data).then(() => {
                  localforage
                    .setItem('stocklotts', moment().valueOf())
                    .then(() => {
                      resolve(res.data);
                    });
                });
              })
              .catch((error) => {
                console.log(error.response);
                reject(error);
              });
          } else {
            console.log('from cache  ' + 'stocklot');
            localforage
              .getItem('stocklot')
              .then((value) => {
                resolve(value);
              })
              .catch((err) => {
                reject(err);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  this.getInvoices = function () {
    console.log('GET invoices');
    return new Promise((resolve, reject) => {
      localforage
        .getItem('invoicests')
        .then((invoicests) => {
          console.log(invoicests);

          if (
            moment().valueOf() - moment(invoicests).valueOf() >= CACHE_TIME ||
            invoicests === null
          ) {
            console.log('fetching ' + 'invoices');
            axios
              .get('invoices?fields=all')
              .then((res) => {
                localforage.setItem('invoices', res.data).then(() => {
                  localforage
                    .setItem('invoicests', moment().valueOf())
                    .then(() => {
                      resolve(res.data);
                    });
                });
              })
              .catch((error) => {
                console.log(error.response);
                reject(error);
              });
          } else {
            console.log('from cache  ' + 'invoices');
            localforage
              .getItem('invoices')
              .then((value) => {
                console.log('invoices gatherd');
                resolve(value);
              })
              .catch((err) => {
                console.log('error getting invoices from cache', err);
                reject(err);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };
  this.getInvoicesLines = function () {
    console.log('GET invoices lines');
    return new Promise((resolve, reject) => {
      localforage
        .getItem('invoiceslinests')
        .then((invoiceslinests) => {
          console.log(invoiceslinests);
          if (
            moment().valueOf() - moment(invoiceslinests).valueOf() >= CACHE_TIME ||
            invoiceslinests === null
          ) {
            console.log('fetching ' + 'invoices lines');
            axios
              .get('invoices_lines?fields=all')
              .then((res) => {
                localforage.setItem('invoices_lines', res.data).then(() => {
                  localforage
                    .setItem('invoiceslinests', moment().valueOf())
                    .then(() => {
                      resolve(res.data);
                    });
                });
              })
              .catch((error) => {
                console.log(error.response);
                reject(error);
              });
          } else {
            console.log('from cache  ' + 'invoices lines');
            localforage
              .getItem('invoices_lines')
              .then((value) => {
                console.log('invoices lines gatherd');
                resolve(value);
              })
              .catch((err) => {
                console.log('error getting invoices from cache', err);
                reject(err);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };
  
  this.getProducts = function () {
    console.log('GET products');
    return new Promise((resolve, reject) => {
      localforage
        .getItem('productsts')
        .then((productsts) => {
          console.log(productsts);
          if (
            moment().valueOf() - moment(productsts).valueOf() >= CACHE_TIME ||
            productsts === null
          ) {
            console.log('fetching ' + 'products');
            axios
              .get('products?fields=all')
              .then((res) => {
                localforage.setItem('products', res.data).then(() => {
                  localforage
                    .setItem('productsts', moment().valueOf())
                    .then(() => {
                      resolve(res.data);
                    });
                });
              })
              .catch((error) => {
                console.log(error.response);
                reject(error);
              });
          } else {
            console.log('from cache  ' + 'products');
            localforage
              .getItem('products')
              .then((products) => {
                resolve(products);
              })
              .catch((err) => {
                reject(err);
              });
          }
        })
        .catch((err) => {
          reject(err);
          console.log(err);
        });
    });
  };

  this.getVehicles = function () {
    console.log('GET vehicles');
    return new Promise((resolve, reject) => {
      localforage
        .getItem('vehiclests')
        .then((vehiclests) => {
          console.log(vehiclests);
          if (
            moment().valueOf() - moment(vehiclests).valueOf() >= CACHE_TIME ||
            vehiclests === null
          ) {
            console.log('fetching ' + 'vehicles');
            axios
              .get('vehicles?fields=all')
              .then((res) => {
                localforage.setItem('vehicles', res.data).then(() => {
                  localforage
                    .setItem('vehiclests', moment().valueOf())
                    .then(() => {
                      resolve(res.data);
                    });
                });
              })
              .catch((error) => {
                console.log(error.response);
                reject(error);
              });
          } else {
            console.log('from cache  ' + 'vehicles');
            localforage
              .getItem('vehicles')
              .then((vehicles) => {
                resolve(vehicles);
              })
              .catch((err) => {
                reject(err);
              });
          }
        })
        .catch((err) => {
          reject(err);
          console.log(err);
        });
    });
  };

  this.getTmsWayBill = function () {
    console.log('GET tmswaybill');
    return new Promise((resolve, reject) => {
      localforage
        .getItem('tmswaybillts')
        .then((tmswaybillts) => {
          console.log(tmswaybillts);

          if (
            moment().valueOf() - moment(tmswaybillts).valueOf() >= CACHE_TIME ||
            tmswaybillts === null
          ) {
            console.log('fetching ' + 'tmswaybill');
            axios
              .get('tmswaybill?fields=all')
              .then((res) => {
                localforage.setItem('tmswaybill', res.data).then(() => {
                  localforage
                    .setItem('tmswaybillts', moment().valueOf())
                    .then(() => {
                      resolve(res.data);
                    });
                });
              })
              .catch((error) => {
                console.log(error.response);
                reject(error);
              });
          } else {
            console.log('from cache  ' + 'tmswaybill');
            localforage
              .getItem('tmswaybill')
              .then((value) => {
                resolve(value);
              })
              .catch((err) => {
                reject(err);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  this.getTmsWayBillProducts = function () {
    console.log('GET tmswaybillproducts');
    return new Promise((resolve, reject) => {
      localforage
        .getItem('tmswaybillproductsts')
        .then((tmswaybillproductsts) => {
          console.log(tmswaybillproductsts);

          if (
            moment().valueOf() - moment(mswaybillproductsts).valueOf() >=
              CACHE_TIME ||
            tmswaybillproductsts === null
          ) {
            console.log('fetching ' + 'tmswaybill');
            axios
              .get('tmswaybillproducts?fields=all')
              .then((res) => {
                localforage.setItem('tmswaybillproducts', res.data).then(() => {
                  localforage
                    .setItem('tmswaybillproductsts', moment().valueOf())
                    .then(() => {
                      resolve(res.data);
                    });
                });
              })
              .catch((error) => {
                console.log(error.response);
                reject(error);
              });
          } else {
            console.log('from cache  ' + 'tmswaybillproducts');
            localforage
              .getItem('tmswaybillproducts')
              .then((value) => {
                resolve(value);
              })
              .catch((err) => {
                reject(err);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };
}
 export {restService};
